/**
 * The standard conditions for a simple query string search.
 *
 * - The query as given in the input.
 * - The query post-fixed with a wildcard.
 * - The query with whitespaces removed.
 *
 * @param {string[]} fields The fields to search on.
 * @param {string} query The query string.
 * @param {string} operator The operator to use, default 'or'.
 *
 * @returns {Object} The transformed query string.
 */
export const simpleQueryString = (fields, query, operator = 'or') => {
  const value = query
    .toString()
    .replace(/(["'])/g, '\\$1')
    .toLowerCase();

  return {
    simple_query_string: {
      query: `${value} | ${value}* | ${value.replace(/\s+/g, '')}`,
      fields,
      default_operator: operator,
    },
  };
};

/**
 * Create wildcard queries for each field.
 *
 * @param {string[]} fields The fields to create the wildcard for.
 * @param {string} query The query to search on.
 *
 * @returns {Array} The wildcards to search on.
 */
export const wildcards = (fields, query) => {
  const value = query
    .toString()
    .replace(/(["'])/g, '\\$1')
    .toLowerCase();

  return fields.map((field) => ({ wildcard: { [field]: `*${value}*` } }));
};
